/**
 * @generated SignedSource<<dd1bfa23c6ff00d0d8437d42384908e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutLayout_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_item" | "CheckoutFooter_item" | "CheckoutFrame_item" | "CheckoutMobileCancelationPolicy_item" | "CheckoutMobileSummaryPane_item" | "CheckoutSidebar_item" | "CheckoutSteps_item">;
  readonly " $fragmentType": "CheckoutLayout_item";
};
export type CheckoutLayout_item$key = {
  readonly " $data"?: CheckoutLayout_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutLayout_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPane_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebar_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutFrame_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSteps_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileCancelationPolicy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutFooter_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerIncentives_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "8836e543212e72da4536e5574fdc0d3b";

export default node;
